import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../constants/enums";
import {
  APP_FILE_EMAIL_STATISTICS_ROUTE,
} from "./EmailStatistics.constants";

const EmailStatistics= Loadable(
  lazy(() =>
    import("./EmailStatistics").then(({ EmailStatistics }) => ({
      default: EmailStatistics,
    }))
  )
);

export const EmailStatisticsRoutes = [
  {
    path: `${ APP_FILE_EMAIL_STATISTICS_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute moduleKeys={[MODULE_IDS.COMMUNICATION]}>
        <EmailStatistics />
      </AuthorizedRoute>
    ),
  },
];
